// src/components/api/AuditLogApiService.js
import { apiClient } from './ApiClient';

/**
 * @param {{ entityType:string,
 *           entityId:number,
 *           username:string,
 *           fromDateTime:string,
 *           toDateTime:string }} filters
 */
export const retrieveAllAuditLogsApi = (filters) =>
  apiClient.get('/audit-logs', {
    params: {
      entityType:   filters.entityType,
      entityId:     filters.entityId,
      username:     filters.username,
      fromDateTime: filters.fromDateTime,
      toDateTime:   filters.toDateTime,
    }
  });

  export const retrieveShippingInstructionClosingDateApi = () =>
  apiClient.get(`/audit-logs/shipping-instructions/status-closed`);